import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Range } from 'rc-slider';
import styled from 'styled-components';
import { actions as assetActions } from '../../actions/asset';
import { actions as clipperMovieActions } from '../../actions/clipperMovie';
import { getTimeCode } from '../../util/timecode';

const $ = window.$;

const GraphicItem = styled.div`
  font-size: 9pt;
  padding: .25rem;
  position: absolute;
  left: ${props => (props.start / 10)}%;
  height: 46px;
  top: 0;
  width: ${props => ((props.end - props.start) / 10)}%;
  word-wrap: normal;
  z-index: 4;
`;

const UnselectedGraphic = styled(GraphicItem)`
  border: 1px solid #e0e0e0;
  z-index: 2;
`;

const GraphicText = styled.div`
  display: inline-block;
  height: calc(46px - .5rem);
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: top;
  width: 100%;
`;

const TooltipText = styled.div`
  background-color: rgba(255, 255, 255, 0.9);
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  padding: 2px 4px;
  position: absolute;
  top: -26px;
`;

const DurationText = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  display: ${props => (props.visible ? 'inline-block' : 'none')};
  padding: 2px 4px;
  position: absolute;
  top: 50px;
`;

class TimelineGraphic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isDragging: false,
      isStartHandle: false
    };

    this.handleOnClick = this.handleOnClick.bind(this);
    this.handleOnDoubleClick = this.handleOnDoubleClick.bind(this);
    this.handleOnChangeRange = this.handleOnChangeRange.bind(this);
  }
  componentDidMount() {
    $(this.container)
      .on('click', this.handleOnClick)
      .on('dblclick', this.handleOnDoubleClick);
  }

  componentWillUnmount() {
    $(this.container)
      .off('click', this.handleOnClick)
      .off('dblclick', this.handleOnDoubleClick);
  }
  handleOnClick() {
    this.props.onClick(this.props.graphic.id);
  }
  handleOnDoubleClick(event) {
    event.stopPropagation();
    this.props.onOpenClipperMosObject(this.props.graphic.mosXml);
  }
  handleOnChangeRange(id, value) {
    const newStart = value[0];
    const newEnd = value[1];
    const isStartHandle = newStart !== this.props.graphic.start;
    this.setState({ isStartHandle });
    this.props.onChangeRange(id, newStart, newEnd, isStartHandle);
  }
  renderRangeSliderView(graphic) {
    const { durationInMs, frameRate } = this.props;
    return (
      <div>
        <Range
          min={0}
          max={1000}
          defaultValue={[graphic.start, graphic.end]}
          allowCross={false}
          onBeforeChange={() => this.setState({ isDragging: true })}
          onChange={(value) => this.handleOnChangeRange(graphic.id, value)}
          onAfterChange={() => this.setState({ isDragging: false })}
        />
        <TooltipText visible={this.state.isDragging} style={{ left: `calc(${(this.state.isStartHandle ? graphic.start : graphic.end) / 10}% - 42px)` }}>
          {
            this.state.isStartHandle ?
              getTimeCode(graphic.start, durationInMs, frameRate) :
              getTimeCode(graphic.end, durationInMs, frameRate)
          }
        </TooltipText>
        <DurationText visible={this.state.isDragging} style={{ left: `calc(${graphic.end / 10}% - 58px)` }}>
          Dur: {getTimeCode((graphic.end - graphic.start), durationInMs, frameRate)}
        </DurationText>
        <GraphicItem
          title={graphic.title}
          start={graphic.start}
          end={graphic.end}
        >
          <GraphicText selected>
            {graphic.title}
          </GraphicText>
        </GraphicItem>
      </div>
    );
  }
  renderDisplayOnlyView(graphic) {
    const textView = graphic.end - graphic.start > 50 ?
      (<GraphicText selected={false}>
        {graphic.title}
      </GraphicText>) :
      null;

    const style = this.props.enabled ?
        { background: 'rgba(214, 233, 253, .7)', border: '1px solid #e0e0e0' } :
        { background: 'rgba(0, 0, 0, .1)', border: '1px solid transparent' };

    return (
      <UnselectedGraphic
        style={style}
        title={graphic.title}
        start={graphic.start}
        end={graphic.end}
      >
        {textView}
      </UnselectedGraphic>
    );
  }
  render() {
    const { graphic } = this.props;
    const content = graphic.selected ?
      this.renderRangeSliderView(graphic) :
      this.renderDisplayOnlyView(graphic);

    return (
      <div ref={(div) => { this.container = div; }}>
        {content}
      </div>
    );
  }
}

TimelineGraphic.propTypes = {
  enabled: PropTypes.bool.isRequired,
  durationInMs: PropTypes.number.isRequired,
  frameRate: PropTypes.number.isRequired,
  graphic: PropTypes.shape({
    id: PropTypes.number.isRequired,
    duration: PropTypes.string.isRequired,
    end: PropTypes.number.isRequired,
    mosObjectId: PropTypes.string.isRequired,
    mosXml: PropTypes.string.isRequired,
    selected: PropTypes.bool.isRequired,
    start: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  onOpenClipperMosObject: PropTypes.func.isRequired,
  onChangeRange: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  durationInMs: state.clipperMovie.durationInMs,
  frameRate: state.clipperMovie.frameRate
});

const mapDispatchToProps = {
  onOpenClipperMosObject: assetActions.openClipperMosObject,
  onChangeRange: clipperMovieActions.updateGraphicPosition
};

export default connect(mapStateToProps, mapDispatchToProps)(TimelineGraphic);



// WEBPACK FOOTER //
// ./app/components/Clipper/TimelineGraphic.js